(function () {
  if (window.gridSliderReady) return;
  window.gridSliderReady = true;

  var CAROUSEL = '.fc.is-scrollable';
  var hydrated = new WeakSet();

  function cardFrom(target) {
    return target && target.closest ? target.closest('.grid-product') : null;
  }

  function inCarousel(element) {
    return !!(element && element.closest && element.closest(CAROUSEL));
  }

  function hydrateSlider(card) {
    if (inCarousel(card)) return;
    var template = card.querySelector('template[data-grid-slider-template]');
    if (template) template.replaceWith(template.content);
  }

  function hydrateVariants(card) {
    var template = card.querySelector('template[data-card-variant-options]');
    if (!template) return;
    var select = card.querySelector('[data-card-variant-select]');
    if (select) {
      var current = select.value;
      select.replaceChildren(template.content);
      select.value = current;
    }
    template.remove();
  }

  function hydrateCard(card) {
    if (!card || hydrated.has(card)) return;
    hydrated.add(card);
    hydrateSlider(card);
    hydrateVariants(card);
  }

  function preload(slider, index) {
    var image = slider.querySelector('[data-grid-slide="' + index + '"] img');
    if (image) image.loading = 'eager';
  }

  function nextIndex(slider) {
    var count = parseInt(slider.getAttribute('data-count'), 10) || 1;
    var index = parseInt(slider.getAttribute('data-index'), 10) || 0;
    return (index + 1) % count;
  }

  function go(slider, direction) {
    var count = parseInt(slider.getAttribute('data-count'), 10) || 1;
    var index = parseInt(slider.getAttribute('data-index'), 10) || 0;
    index = (index + direction + count) % count;
    slider.setAttribute('data-index', index);
    slider.querySelectorAll('[data-grid-slide]').forEach(function (slide) {
      slide.classList.toggle('is-active', parseInt(slide.getAttribute('data-grid-slide'), 10) === index);
    });
    slider.querySelectorAll('.grid-slider__dot').forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === index);
    });
    preload(slider, (index + 1) % count);
  }

  function sliderFromTouch(target, touch) {
    if (!target || !target.closest) return null;
    if (inCarousel(target)) return null;
    if (target.closest('[data-card-atc], .card-atc, [data-card-variant-select]')) return null;
    var card = cardFrom(target);
    if (!card) return null;
    var mask = card.querySelector('.grid-product__image-mask');
    var slider = mask ? mask.querySelector('[data-grid-slider]') : null;
    if (!slider) return null;
    var rect = mask.getBoundingClientRect();
    if (touch.clientX < rect.left || touch.clientX > rect.right || touch.clientY < rect.top || touch.clientY > rect.bottom) return null;
    return slider;
  }

  function showNotice(message) {
    var notice = document.getElementById('atc-notification');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'atc-notification';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      document.body.appendChild(notice);
    }
    notice.textContent = message;
    notice.classList.add('show');
    clearTimeout(notice.hideTimer);
    notice.hideTimer = setTimeout(function () {
      notice.classList.remove('show');
    }, 3000);
  }

  function getVariantId(button) {
    var card = button.closest('.grid-product');
    var select = card ? card.querySelector('[data-card-variant-select]') : null;
    var value = select ? select.value : button.getAttribute('data-variant-id');
    return parseInt(value, 10);
  }

  function addToCart(button) {
    var variantId = getVariantId(button);
    if (!variantId) return;
    button.classList.add('is-loading');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        button.classList.remove('is-loading');
        if (!result.ok) {
          var message = (result.data && (result.data.description || result.data.message)) || 'Tuotetta ei voitu lisätä ostoskoriin.';
          showNotice(message);
          return;
        }
        button.classList.add('is-added');
        setTimeout(function () {
          button.classList.remove('is-added');
        }, 1500);
        var item = result.data && result.data.items ? result.data.items[0] : result.data;
        if (document.getElementById('CartDrawer')) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: button } }));
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () {
        button.classList.remove('is-loading');
        showNotice('Tuotetta ei voitu lisätä ostoskoriin.');
      });
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType !== 'touch') hydrateCard(cardFrom(event.target));
  }, { passive: true });

  document.addEventListener('focusin', function (event) {
    hydrateCard(cardFrom(event.target));
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-card-variant-select]');
    if (!select) return;
    var card = select.closest('.grid-product');
    var button = card ? card.querySelector('[data-card-atc]') : null;
    if (button) button.setAttribute('data-variant-id', select.value);
  });

  document.addEventListener('click', function (event) {
    var select = event.target.closest('[data-card-variant-select]');
    if (select) {
      event.stopPropagation();
      if (select.closest('a')) event.preventDefault();
      return;
    }
    var atc = event.target.closest('[data-card-atc]');
    if (atc) {
      event.preventDefault();
      event.stopPropagation();
      if (!atc.classList.contains('is-loading')) addToCart(atc);
      return;
    }
    var button = event.target.closest('[data-grid-slider-prev], [data-grid-slider-next]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      var slider = button.closest('[data-grid-slider]');
      if (slider) go(slider, button.hasAttribute('data-grid-slider-next') ? 1 : -1);
    }
  }, true);

  var touchSlider = null;
  var startX = 0;
  var startY = 0;
  var swiped = false;

  document.addEventListener('touchstart', function (event) {
    hydrateCard(cardFrom(event.target));
    var touch = event.touches[0];
    swiped = false;
    touchSlider = sliderFromTouch(event.target, touch);
    if (!touchSlider) return;
    startX = touch.clientX;
    startY = touch.clientY;
    preload(touchSlider, nextIndex(touchSlider));
  }, { passive: true, capture: true });

  document.addEventListener('touchend', function (event) {
    if (!touchSlider) return;
    var touch = event.changedTouches[0];
    var dx = touch.clientX - startX;
    var dy = touch.clientY - startY;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
      go(touchSlider, dx < 0 ? 1 : -1);
      swiped = true;
    }
    touchSlider = null;
  }, { passive: true, capture: true });

  document.addEventListener('touchcancel', function () {
    touchSlider = null;
  }, { passive: true, capture: true });

  document.addEventListener('click', function (event) {
    if (!swiped) return;
    swiped = false;
    event.preventDefault();
    event.stopPropagation();
  }, true);
})();